import Box from '@mui/material/Box';

import PageMainContentBox from '../../components/PageMainContentBox';
import UserDocumentsPage from './User/UserDocumentsPage';
import DeniedAccess from '../../components/DeniedAccess';

import useAuthContext from '../../hooks/useAuthContext';

import roleBasedRender from '../../utils/roleBasedRender';

// role based render = user only
export default function UserDocuments() {
  const { userInfo } = useAuthContext();

  const role = userInfo ? userInfo.user.roles[0].nome : '';

  return (
    <Box style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
      <PageMainContentBox title="Documentos" page="documentos" overflow="auto">
        {roleBasedRender(
          role,
          <UserDocumentsPage />,
          <DeniedAccess />,
          <DeniedAccess />,
          null,
        )}
      </PageMainContentBox>
    </Box>
  );
}
